import { useAtom, atom } from 'jotai';
import { useCallback } from 'react';
import { createModalState } from './utils/create-modal-state';

// Sign-in modal with intended destination
const signInModalAtom = atom<{ isOpen: boolean; intendedPath?: string }>({
  isOpen: false,
  intendedPath: undefined,
});

export const useSignInModal = () => {
  const [state, setState] = useAtom(signInModalAtom);

  const open = useCallback(
    (intendedPath?: string) => {
      setState({ isOpen: true, intendedPath });
    },
    [setState]
  );

  const close = useCallback(() => {
    setState({ isOpen: false, intendedPath: undefined });
  }, [setState]);

  return {
    isOpen: state.isOpen,
    intendedPath: state.intendedPath,
    open,
    close,
  };
};
export const useCancelSubscriptionModal = createModalState();
export const useUpgradeSubscriptionModal = createModalState();
export const useDowngradeSubscriptionModal = createModalState();
export const useResumeSubscriptionModal = createModalState();
export const usePurchaseSubscriptionModal = createModalState();
export const useSupportModal = createModalState();
export const useVideoDemosModal = createModalState();
export const useBillingStatusModal = createModalState();
export const useRefundRequestModal = createModalState();
